import http from '@/utils/services/http'

export default {

  lista (limit, page, filtros) {
    let url = '/api/grv/listaLogsDetro?page=' + page + '&limit=' + limit + filtros
    return http.get(url) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }

}



// WEBPACK FOOTER //
// ./src/domain/logs/services/index.js